// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610061233/js/" + chunkId + "." + {"44":"dcf72d29","225":"85d88575","481":"75d24b80","486":"56dd48f9","770":"6e185fc6"}[chunkId] + ".0.5245278246695687.chunk.js";
};